import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

/**
 * Welcoming banner for a manager whose facility already has a licence that has
 * never been paid (admin-onboarded → ACTIVE but last_payment_date is null).
 *
 * Deliberately NOT the shared PaymentDueBanner (red "payment overdue" styling):
 * this is a friendly first-time onboarding prompt, so it uses an informational
 * blue tone and no payment/suspension wording.
 */
export const FirstPaymentBanner: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div
      data-testid="first-payment-banner"
      className="flex flex-wrap items-center gap-3 px-6 py-4 border-b bg-blue-50 border-blue-200 text-blue-800"
    >
      <div className="flex-1 min-w-[200px]">
        <p className="text-sm font-semibold">{t("banner.firstPayment.title")}</p>
        <p className="text-xs mt-0.5 text-blue-700">
          {t("banner.firstPayment.subtitle")}
        </p>
      </div>
      <button
        onClick={() => navigate("/manager/licence")}
        className="px-4 py-2 text-sm font-medium text-white transition-colors rounded-lg bg-blue-600 hover:bg-blue-700"
      >
        {t("banner.firstPayment.cta")}
      </button>
    </div>
  );
};
